export interface PermitType {
  id: string;
  name: string;
  type: string;
  jurisdiction: string;
  originalId: string;
  isActive?: boolean;
}

export class PermitTypeList {
  constructor(public readonly permitTypes: PermitType[]) {}
}
